<template>
  <div class="banner" v-if="!emailValidated">
    <div class="banner-inner">
      <span class="banner-text">
        Profitez d'un essai gratuit de 15 jours pour découvrir nos outils dédiés à votre pratique !
      </span>
      <button class="banner-btn" @click="handleSubscribe">
        Je profite !
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopBanner',
  props: {
    emailValidated: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleSubscribe() {
      this.$emit('subscribe');
    }
  }
}
</script>

<style scoped>
.banner {
  background: #239380;
  color: white;
  padding: 16px;
}

.banner-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.banner-text {
  font-size: 16px;
  text-align: center;
  line-height: 1.4;
}

.banner-btn {
  background: white;
  color: #239380;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.banner-btn:hover {
  background: #f5f5f5;
}

/* Responsive */
@media (max-width: 768px) {
  .banner-inner {
    flex-direction: column;
    gap: 12px;
  }
  
  .banner-btn {
    width: 100%;
    max-width: 200px;
  }
}
</style>